export const gray = (level) => {
  const levels = {
    100: "#f8f8f8",
    200: "#eeeeee",
    300: "#cccccc",
    400: "#6a6a6a",
    500: "#1a1a1a",
    default: "#cccccc",
  };
  return levels[+level] || levels.default;
};

export const red = () => "#e35141";
